// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__t3S72","img":"Footer_img__QNURN","social":"Footer_social__NjCAl","socialImg":"Footer_socialImg__AICEy","links":"Footer_links__gaPg2"};